
function autoAddClass() 
{
  
    var next = document.querySelector( '.quiz_intro_slider.only_desktop .active' );
    
    if ( next ) 
    {
      next.classList.remove( 'active' );
      next = next.nextElementSibling;
    }

    if ( next ) 
    {
      next.classList.add( 'active' );
    } 
    else 
    {
        document.querySelector( '.quiz_intro_slider.only_desktop .intro_content_style' ).classList.add( 'active' );
    }
  
    var next_animation = document.querySelector( '.welleasy_quiz_intro_animation .active' );
    
    if ( next_animation ) 
    {
        next_animation.classList.remove( 'active' );
        next_animation = next_animation.nextElementSibling;
    }

    if ( next_animation ) 
    {
        
        next_animation.classList.add( 'active' );
    } 
    else 
    {
        document.querySelector( '.welleasy_quiz_intro_animation .intro_content_animation' ).classList.add( 'active' );
    }
  
    setTimeout( autoAddClass, 3500 );
}
//************/ quiz intro section animation *******//
document.addEventListener('DOMContentLoaded', function() 
{
    var introDivs = document.querySelectorAll( ".intro_content_style" );

    function animateDivs( index ) 
    {
        if ( index >= introDivs.length ) return;

        setTimeout( function() 
        {
            introDivs[ index ].classList.add( "animate" );
            animateDivs( index + 1 );
        }, 700 );
    }
    var intro_animations = document.querySelectorAll( '.intro_animation' )
    intro_animations.forEach(function( intro_animation ) 
    {
        intro_animation.addEventListener( "click", function(e)
        {
            animateDivs(0);
        });
    });
    
});

function initslider() 
{
    $( '.quiz_intro_slider.only_mobile' ).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        asNavFor: '.animation_wrapper.only_mobile'
    });

    $('.animation_wrapper.only_mobile').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        asNavFor: '.quiz_intro_slider.only_mobile',
      });
}

// $( document ).ready( function () 
// {
//     var intro_animation = document.querySelector( '.intro_animation' )
//     intro_animation.addEventListener("click", function(e)
//     {
//         autoAddClass();
//     });

// });